export default __webpack_public_path__ + "static/DUBIZZLELABS-FULL-COLOUR-ee0ffcb14214e71e72b13e4b83fe856a.png";